import {RouteLocationNormalized, RouterView} from "vue-router";
import {useServiceStore} from "@/stores/service/service";
import {IBreadcrumbMeta} from "@/interfaces/IBreadcrumbMeta";
// import {IBreadcrumbMeta} from "cdp-fe-commons-layout";

const Services = () => import('@/views/services/Services.vue')
const ServiceDetail = () => import('@/views/services/ServiceDetail.vue')
const OnlineRequestForm = () => import('@/views/istanze/OnlineRequestForm.vue')

const servicesRoutes = [
    {
        path: 'catalogo',
        name: 'CatalogoPI',
        meta: {
            breadcrumb: {
                customName: "Procedimenti"
            } as IBreadcrumbMeta,
            requiresAuth: true
        },
        component: RouterView,
        children: [
            {
                path: '',
                name: 'Catalogo',
                component: Services,
                meta: {
                    breadcrumb: {
                        exclude: true
                    } as IBreadcrumbMeta,
                    requiresAuth: true
                },
            },
            {
                path: ':codiceCatalogo',
                name: 'CatalogoDetail',
                component: RouterView,
                meta: {
                    breadcrumb: {
                        customNameBeforeResolve: (to: RouteLocationNormalized) => {
                            const codiceCatalogo = to.params.codiceCatalogo as string ?? '';
                            const serviceStore = useServiceStore();
                            return serviceStore.getServiceTitle(codiceCatalogo);
                        },
                    } as IBreadcrumbMeta,
                    requiresAuth: true
                },
                children: [
                    {
                        path: '',
                        name: 'ProcedimentoInterno',
                        component: ServiceDetail,
                        meta: {
                            breadcrumb: {exclude: true} as IBreadcrumbMeta,
                            requiresAuth: true,
                        },
                    },
                    {
                        path: 'richiestaonline/:codiceIstanza',
                        name: "Compila richiesta da servizi",
                        meta: {
                            requiresAuth: true,
                            breadcrumb: {
                                customName: "Compila Online"
                            } as IBreadcrumbMeta
                        },
                        component: OnlineRequestForm,
                    }
                ]
            },
        ]
    },
];

export default servicesRoutes;
